import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import UtcDateTimeField from "./UtcDateTimeField";

interface ScheduleFieldsProps {
  startDate?: string | null;
  endDate?: string | null;
  savedStartDate?: string | null;
  savedEndDate?: string | null;
  disabled?: boolean;
  itemLabel: string;
  onChange: (field: "startDate" | "endDate", value: string | null) => void;
}

const ScheduleFields = ({
  startDate,
  endDate,
  savedStartDate,
  savedEndDate,
  disabled,
  itemLabel,
  onChange,
}: ScheduleFieldsProps) => {
  const endMinValue = startDate
    ? new Date(new Date(startDate).getTime() + 1000).toISOString()
    : null;

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Leave blank to manage this {itemLabel} by hand. When set, it turns on
        at the <b>Start Date</b> and off at the <b>End Date</b>, to the second,
        in <b>UTC</b>, and it is archived once the <b>Content Auto-Archive
        Time</b> from Configurations has passed after the End Date (24 hours
        by default).
      </Typography>
      {disabled && (
        <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }}>
          Status is <b>Active</b>, so this {itemLabel} is managed by hand.
          Switch the status off to choose a schedule.
        </Alert>
      )}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        <Box sx={{ width: 260 }}>
          <UtcDateTimeField
            label="Start Date"
            name="startDate"
            value={startDate}
            savedValue={savedStartDate}
            disabled={disabled}
            onChange={(value) => onChange("startDate", value)}
          />
        </Box>
        <Box sx={{ width: 260 }}>
          <UtcDateTimeField
            label="End Date"
            name="endDate"
            value={endDate}
            minValue={endMinValue}
            savedValue={savedEndDate}
            disabled={disabled}
            onChange={(value) => onChange("endDate", value)}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ScheduleFields;
